import {useSearchParams} from "react-router-dom";
import {useMemo} from "react";
import {IApiProviderProto} from "../../provider_api";

export const useImpersonation = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  const impersonatedBusiness = searchParams.get('ib');
  const impersonatedProvider = searchParams.get('ip');

  const setImpersonatedBusiness = (businessId: string | null | undefined) => {
    if (businessId) {
      setSearchParams({ib: businessId})
    } else {
      setSearchParams({});
    }
  }

  /**
   * When impersonating a provider, the business ID should be set as well.
   */
  const setImpersonatedProvider = (provider: IApiProviderProto | null | undefined) => {
    if (provider) {
      setSearchParams({ib: provider.businessId as string, ip: provider.providerId as string});
    } else {
      setSearchParams({})
    }
  }

// Memoization is highly important because ProviderProfileProvider depends on this
// and it re-loads the business every time this changes.
  return useMemo(() => {
    return {
      impersonatedBusiness,
      impersonatedProvider,
      setImpersonatedBusiness,
      setImpersonatedProvider
    }
  }, [impersonatedBusiness, impersonatedProvider]);
}

